import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_FOOTER = "https://customer-assets.emergentagent.com/job_agglos-producer/artifacts/41b3vasp_14.png";

export default function Footer() {
  return (
    <footer className="bg-[#0A1320] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <img src={LOGO_FOOTER} alt="AGRABAT" className="h-16 mb-6" />
            <p className="text-slate-400 text-sm leading-relaxed">
              AGRABAT, votre partenaire de confiance pour les matériaux de construction au Sénégal. 
              Granulats de silex et agglos de qualité supérieure.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-oswald text-lg font-semibold uppercase tracking-wider mb-6 text-[#FFD100]">
              Navigation
            </h4>
            <ul className="space-y-3">
              {[
                { name: "Accueil", path: "/" },
                { name: "Produits", path: "/produits" },
                { name: "Services", path: "/services" },
                { name: "À Propos", path: "/a-propos" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-[#FFD100] transition-colors text-sm"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-oswald text-lg font-semibold uppercase tracking-wider mb-6 text-[#FFD100]">
              Nos Produits
            </h4>
            <ul className="space-y-3">
              <li className="text-slate-400 text-sm">Granulats de Silex 0/3</li>
              <li className="text-slate-400 text-sm">Granulats de Silex 3/8</li>
              <li className="text-slate-400 text-sm">Granulats de Silex 8/16</li>
              <li className="text-slate-400 text-sm">Agglos 10x20x40</li>
              <li className="text-slate-400 text-sm">Agglos 15x20x40</li>
              <li className="text-slate-400 text-sm">Agglos 20x20x40</li>
              <li className="text-slate-400 text-sm">Agglos Plein 15x20x40</li>
              <li className="text-slate-400 text-sm">Hourdis 16x20x40</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-oswald text-lg font-semibold uppercase tracking-wider mb-6 text-[#FFD100]">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#FFD100] mt-0.5 flex-shrink-0" />
                <div className="text-slate-400 text-sm">
                  <p className="font-medium text-white">Siège Social</p>
                  <p>190 Avenue Lamine Gueye</p>
                  <p>Thiès, Sénégal</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#FFD100] mt-0.5 flex-shrink-0" />
                <div className="text-slate-400 text-sm">
                  <p className="font-medium text-white">Site Agglos</p>
                  <p>Sortie N°2 Autoroute</p>
                  <p>Thiès</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#FFD100] mt-0.5 flex-shrink-0" />
                <div className="text-slate-400 text-sm">
                  <p className="font-medium text-white">SILIKA GRANULATS</p>
                  <p>Darou Khoudoss</p>
                  <p>zone ICS</p>
                </div>
              </li>
              <li>
                <a href="tel:+221775472760" className="flex items-center gap-3 text-slate-400 hover:text-[#FFD100] transition-colors" data-testid="footer-phone">
                  <Phone className="w-5 h-5 text-[#FFD100]" />
                  <span className="text-sm">+221 77 547 27 60</span>
                </a>
              </li>
              <li>
                <a href="mailto:contact@agrabat.sn" className="flex items-center gap-3 text-slate-400 hover:text-[#FFD100] transition-colors" data-testid="footer-email">
                  <Mail className="w-5 h-5 text-[#FFD100]" />
                  <span className="text-sm">contact@agrabat.sn</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} AGRABAT. Tous droits réservés.
            </p>
            <p className="text-slate-500 text-sm">
              Matériaux de construction de qualité au Sénégal
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
